export const plotOptionsSet = ({ detailsChartRef, }) => ({
    plotOptions: {
        series: {
            events: {
                legendItemClick(event) {
                    const { visible } = this;
                    if (detailsChartRef && detailsChartRef.current) {
                        const series = detailsChartRef === null || detailsChartRef === void 0 ? void 0 : detailsChartRef.current.chart.series[event.target.index];
                        if (series) {
                            if (visible) {
                                series.hide();
                            }
                            else {
                                series.show();
                            }
                        }
                    }
                },
            },
        },
    },
});
//# sourceMappingURL=plotOptionsSet.js.map